editListPickerBoxController.$inject = ['$scope',
    '$mdDialog',
    'elementData',
    'elementView'];

export function editListPickerBoxController($scope,
    $mdDialog,
    elementData,
    elementView) {

    $scope.ok = ok;
    $scope.cancel = cancel;
    $scope.site = "site";
    $scope.companyId = "companyId";

    $scope.elementData = elementData;
    $scope.elementView = elementView;
    /**
     * Options given into the WYSIWYG.
     */
    $scope.options = {
        // TODO replace by maxCharsNumber once site strategies are merged together.
        // If doesn't exist in the element configuration, this one is ignored. 
        maxCharsNumber: elementView.getConfigurationOption('body-max-length'),
    };

    if (elementData.message) {
        $scope.initialListPickerQuestionModel = elementData.message;
    } else {
        $scope.initialListPickerQuestionModel = {
            'text': elementData.description
        };
    }
    $scope.listPickerQuestionModelAccessor = {};
    $scope.listPickerQuestionTextIsEmpty = false;

    function ok() {
        let listPickerQuestionModel = $scope.listPickerQuestionModelAccessor.getModelOfFirstMessage();

        $scope.elementData.message = listPickerQuestionModel;
        elementData.description = listPickerQuestionModel["text"];
        $mdDialog.hide({ type: 'ok', data: elementData });
    }

    function cancel() {
        $mdDialog.cancel();
    }

}